import React from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import Styles from "./styles.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
    setCabinetPartnersPointsHistoryModalStatus
} from "../../../store/cabinet/action";


const CabinetPartnersPointsHistoryModal = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const modalStatus = useSelector(store => store.cabinet.cabinetPartnersPointsHistoryModalStatus);

    const closeModal = () => {
        dispatch(setCabinetPartnersPointsHistoryModalStatus(false));
    };


    return (
        <Popup
            open={!!modalStatus}
            modal
            nested
            closeOnDocumentClick={true}
            onClose={closeModal}
            className="cabinetPartnersPointsHistoryModal"
        >
            <div className={Styles.modalContainer}>
                <div
                    className={`${Styles.modalCloseBtn}`}
                    onClick={closeModal}
                >
                    <div />
                    <div />
                </div>

                <div className={Styles.modalContentWrap}>

                </div>
            </div>
        </Popup>
    );
};

export default CabinetPartnersPointsHistoryModal;
